import "./ErrorPage.scss";
import { useParams } from "react-router-dom";
import { t } from "../i18n";

interface ErrorPageProps {
  type: ErrorPageTypes;
  children?: (userAction: String) => React.ReactNode;
}

export enum ErrorPageTypes {
  MAYAMINIAPP = "mayaminiapp",
  MAYAMINIAPP_LOGGED_OUT = "mayaminiapp-logged-out",
  GLIFE = "glife",
  GLIFE_UNDER_AGE = "glife-under-age",
  GLIFE_LOGGED_OUT = "glife-logged-out",
  GLIFE_USER_DID_NOT_CONSENT_DATA_SHARING = "glife-user-did-not-consent-data-sharing",
  USER_BLOCKED = "user-blocked",
}

const ErrorPage = ({ type, children }: ErrorPageProps) => {
  const { errorType } = useParams<{ errorType: string }>();
  const title = t(`errorPage.${errorType}.title`);
  const description = t(`errorPage.${errorType}.description`);
  const userAction = t(`errorPage.${errorType}.userAction`);

  return (
    <div className="error-page">
      {title && <h1>{title}</h1>}
      {description && <p>{description}</p>}
      {children && children(userAction)}
    </div>
  );
};

export default ErrorPage;
